import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FormikSingleSelect } from "~/components/Formik/FormikSingleSelect";
/**
 * @description A few of the valid image extensions that an imgix image url can be created for
 * @see https://docs.imgix.com/apis/rendering/format/fm
 */ export const defaultImageExtOptions = [
    {
        label: "JPG",
        value: "jpg"
    },
    {
        label: "PNG",
        value: "png"
    },
    {
        label: "WEBP",
        value: "webp"
    }
];
export const defaultImageSizeOptions = [
    {
        label: "1x (Original)",
        value: "1"
    },
    {
        label: ".5x",
        value: "0.5"
    },
    {
        label: "Custom",
        value: "0"
    }
];
export const ImageFormatField = (param)=>{
    let { bottomAdornment, disabled, options: imageSizeOptions, label, name, rightAdornment, "data-testid": testId, onFocus, className } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: className,
                children: [
                    /*#__PURE__*/ _jsx(FormikSingleSelect, {
                        disabled: disabled,
                        "data-testid": testId,
                        isSearchable: false,
                        label: label,
                        name: name,
                        options: imageSizeOptions,
                        size: "extra-large",
                        onOptionsClose: ()=>{
                            onFocus(false);
                        },
                        onOptionsOpen: ()=>{
                            onFocus(true);
                        }
                    }),
                    rightAdornment
                ]
            }),
            bottomAdornment
        ]
    });
};
